module.exports = {"220881001":"团结街道","220881002":"富文街道","220881003":"光明街道","220881004":"兴隆街道","220881005":"永康街道","220881006":"通达街道","220881007":"洮府街道","220881008":"向阳街道","220881100":"瓦房镇","220881101":"万宝镇","220881102":"黑水镇","220881103":"那金镇","220881104":"安定镇","220881105":"福顺镇","220881200":"胡力吐蒙古族乡","220881201":"万宝乡","220881202":"聚宝乡","220881203":"东升乡","220881204":"野马乡","220881205":"永茂乡","220881206":"蛟流河乡","220881207":"大通乡","220881209":"二龙乡","220881210":"呼和车力蒙古族乡","220881400":"东方红畜牧场","220881401":"永茂林场","220881402":"市原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220881.json
// module id = 662
// module chunks = 0